// Generated by ts-to-zod
import { z } from 'zod';

export const requestDemoPayloadSchema = z.object({
  email: z.string(),
  phone: z.string(),
  extraInfo: z.string().optional(),
});
